import { format } from "date-fns";

function activityAt(item, updated) {
  if (updated) return item.last_modified || item.created_at || item.date_of_creation;
  return item.created_at || item.date_of_creation || item.last_modified;
}

export function taskActivity(item = {}) {
  const updatedName = item.updated_by?.full_name;
  const createdName = item.created_by?.full_name;
  const updated = Boolean(updatedName);
  const action = updated ? "Updated by" : "Created by";
  const actor = updated ? updatedName : createdName || "Unknown";
  const at = activityAt(item, updated);
  return {
    action,
    actor,
    at,
    line: at ? `${action} ${actor} · ${format(at, "d MMM yyyy, h:mm a")}` : `${action} ${actor}`,
  };
}
